import { UseFormReturn } from "react-hook-form";
import TextEditor from "../Global/Editors/TextEditor";
import NumberEditor from "../Global/Editors/NumberEditor";
import { DTOModule } from "../../types/building";
import { useGlobalData } from "../GlobalDataProvider";
import StaticBox from "../Global/StaticBox";
import { nameof } from "../Global/Utils";
import { IModuleVentilationFTXochFTConfig } from "../../types/ModuleDatas";
import SelectEditor from "../Global/Editors/SelectEditor";
import Module from "module";
import { ModuleTypeId } from "../../types/DBTables";
import { MapTooltip } from "../../types/globalData";

interface IProps {
  module: DTOModule;
  data: any;
  formHook: UseFormReturn;
}

const ConfigVentilationFTXochFT = ({ module, data, formHook }: IProps) => {
  const globalData = useGlobalData();

  const { watch } = formHook;

  const isFTX = module.moduleTypeId === ModuleTypeId.VentilationFTX;

  const återvinningsTyper = globalData.data?.Ventilation.SystemtypÅtervinning.map((v) => v.SystemtypÅtervinning) || [];
  const ventilationsAggregats = globalData.data?.Ventilation.VärmebatteriTyp.map((v) => v.VärmebatteriTyp) || [];

  const kylbatteriList = [""].concat(globalData.data?.Ventilation.KylbatteriTyp.map((v) => v.KylbatteriTyp) || []);
  const kylformList = globalData.data?.Ventilation.Kylform.map((v) => v.Kylform).filter((k) => k !== "Kyla saknas") || [];

  const variabeltFlödeList = globalData.data?.Ventilation.VariabeltFlöde.map((v) => v.VariabeltFlöde) || [];
  const tillverkningsårList = globalData.data?.Ventilation.Tillverkningsår.map((v) => v.Tillverkningsår) || [];
  const motoreffektList = globalData.data?.Ventilation.Motoreffekt.map((v) => v.Motoreffekt) || [];

  //const dbg = formHook.getValues();
  const kylbatteri = watch("kylbatteri");

  const harReduceradeLuftflödeReglerbaraRumsdon = watch("harReduceradeLuftflödeReglerbaraRumsdon");
  const harReduceradeLuftflödeFastaRumsdon = watch("harReduceradeLuftflödeFastaRumsdon");
  const harSeparatFrånluftsfläkt = watch("harSeparatFrånluftsfläkt");
  const motoreffektUppgift = watch("motoreffektUppgift");

  const hasKyla = kylbatteri !== "Kyla saknas";

  return (
    <>
      <div className="row ml-0 mb-3 align-items-end">
        <div className="col-lg-12">
          <StaticBox label="Är ventilationsaggregatet huvudsaklig värmekälla?" text={data[nameof<IModuleVentilationFTXochFTConfig>("ärHuvudsakligtVärmesystem")]}></StaticBox>
          {/* <SelectEditor
            label="Är ventilationsaggregatet den huvudsakliga värmekällan till byggnaden?"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("ärHuvudsakligtVärmesystem")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_ärHuvudsakligtVärmesystem")}
            items={["Nej", "Ja"]}
            formHook={formHook}
            isDisabled={true}
          /> */}
        </div>
      </div>

      <div className="row ml-0 align-items-end">
        {/* <div className="col-lg-12 mb-3">
          <StaticBox label="Benämning på ventilationssystem" text={module.name}></StaticBox>
        </div> */}
        {isFTX ? (
          <div className="col-lg-12">
            <SelectEditor
              label="Ange systemtyp för återvinning"
              fieldName={nameof<IModuleVentilationFTXochFTConfig>("systemtypÅtervinningFTX")}
              tooltipId={nameof<MapTooltip>("VentilationFTXoFT_systemtypÅtervinningFTX")}
              items={återvinningsTyper}
              formHook={formHook}
              options={{
                validate: {
                  required: (v) => {
                    return !v || v === "" ? "Måste fyllas i" : undefined;
                  },
                },
              }}
            />
          </div>
        ) : (
          <></>
        )}

        <div className="col-lg-12">
          <SelectEditor
            label="Ventilationsaggregatets värmebatteri, ange systemtyp"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("eftervärmningsbatteri")}
            tooltipId={isFTX ? nameof<MapTooltip>("VentilationFTX_eftervärmningsbatteri") : nameof<MapTooltip>("VentilationFT_eftervärmningsbatteri")}
            items={ventilationsAggregats}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange systemtyp för värmebatteri" : undefined;
                },
              },
            }}
          />
        </div>
      </div>

      <div className="row ml-0 align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Ventilationsaggregatets kylbatteri, ange systemtyp"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("kylbatteri")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_kylbatteri")}
            items={kylbatteriList}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange systemtyp för kylbatteri" : undefined;
                },
              },
            }}
          />
        </div>
        <div className="col-lg-6">
          <SelectEditor
            label="Ange kylform"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("kylform")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_kylform")}
            isDisabled={kylbatteri !== "Central vattenburen kyla"}
            items={kylformList}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Ange kylform" : undefined;
                },
              },
            }}
          />
        </div>
        {hasKyla ? <></> : <></>}
      </div>
      <div className="row ml-0 align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Är ventilationsaggregatet utrustad med befuktning?"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("harBefuktning")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_harBefuktning")}
            items={["Nej", "Ja"]}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
        <div className="col-lg-6">
          <SelectEditor
            label="Är ventilationsaggregatet utrustad med avfuktare?"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("harLufttork")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_harLufttork")}
            items={["Nej", "Ja"]}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
              },
            }}
          />
        </div>
      </div>

      <div className="row ml-0  align-items-end">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange om ventilationssystemet har reglerbara rumsdon (Ja/Nej)"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("harReduceradeLuftflödeReglerbaraRumsdon")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_harReduceradeLuftflödeReglerbaraRumsdon")}
            items={["", "Ja", "Nej"]}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Välj ja/nej" : undefined;
                },
              },
            }}
          />
        </div>

        <div className="col-lg-6">
          <NumberEditor
            label="Vid reducerat flöde med reglerbara rumsdon, ange normal andel av aggregatets maxflöde (%) "
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("reduceratFlödeRumsdonReglerbara")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_reduceratFlödeRumsdonReglerbara")}
            isDisabled={harReduceradeLuftflödeReglerbaraRumsdon === "Ja" ? false : true}
            min={0}
            max={100}
            formHook={formHook}
            // formatOptions={{ suffix: " %", min: 0, max: 100 }}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste fyllas i" : undefined;
                },
                lessThan: (v) => {
                  return parseFloat(v) > 100 ? "Måste vara mindre än 100" : undefined;
                },
                greaterThan: (v) => {
                  return parseFloat(v) < 0 ? "Måste vara ett positivt tal" : undefined;
                },
              },
            }}
          />
        </div>
        {harReduceradeLuftflödeReglerbaraRumsdon === "Ja" ? <></> : <></>}
      </div>
      <div className="row ml-0">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange om ventilationssystemet har hel- och delfart med fasta rumsdon (Ja/Nej)"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("harReduceradeLuftflödeFastaRumsdon")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_harReduceradeLuftflödeFastaRumsdon")}
            items={["", "Ja", "Nej"]}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Välj ja/nej" : undefined;
                },
              },
            }}
          />
        </div>

        <div className="col-lg-6">
          <NumberEditor
            label="Vid reducerat flöde med fasta rumsdon- ange normal andel av aggregatets maxflöde (%)"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("reduceratFlödeRumsdonFasta")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_reduceratFlödeRumsdonFasta")}
            isDisabled={harReduceradeLuftflödeFastaRumsdon === "Ja" ? false : true}
            // min={0}
            // max={100}
            formHook={formHook}
            options={{
              validate: {
                required: (v) => {
                  return !v ? "Måste anges!" : undefined;
                },
                lessThan: (v) => {
                  return parseFloat(v) > 100 ? "Måste vara mindre än 100" : undefined;
                },
              },
            }}
          />
        </div>
        {harReduceradeLuftflödeFastaRumsdon === "Ja" ? <></> : <></>}
      </div>

      <div className="row ml-0">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange vilken teknisk metod som används för variabelt flöde"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("variabeltFlödeReglermetod")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_variabeltFlödeReglermetod")}
            isDisabled={!(harReduceradeLuftflödeReglerbaraRumsdon === "Ja" || harReduceradeLuftflödeFastaRumsdon === "Ja")}
            items={variabeltFlödeList}
            formHook={formHook}
          />
        </div>
      </div>
      {harReduceradeLuftflödeReglerbaraRumsdon === "Ja" || harReduceradeLuftflödeFastaRumsdon === "Ja" ? <></> : <></>}

      {isFTX && (
        <div className="row ml-0 align-items-end">
          <div className="col-lg-6">
            <SelectEditor
              label="Finns separat frånluftsfläkt som inte ingår i aggregatets återvinningssystem?"
              fieldName={nameof<IModuleVentilationFTXochFTConfig>("harSeparatFrånluftsfläkt")}
              tooltipId={nameof<MapTooltip>("VentilationFTXoFT_harSeparatFrånluftsfläkt")}
              items={["", "Ja", "Nej"]}
              formHook={formHook}
              options={{
                validate: {
                  required: (v) => {
                    return !v ? "Välj ja/nej" : undefined;
                  },
                },
              }}
            />
          </div>

          <div className="col-lg-6">
            <TextEditor
              label="Ange beteckning på separat frånluftssystem"
              fieldName={nameof<IModuleVentilationFTXochFTConfig>("separatFrånluftsfläktBeteckning")}
              tooltipId={nameof<MapTooltip>("VentilationFTXoFT_separatFrånluftsfläktBeteckning")}
              isDisabled={harSeparatFrånluftsfläkt === "Ja" ? false : true}
              formHook={formHook}
              options={{
                validate: {
                  required: (v) => {
                    return !v ? "Måste fyllas i" : undefined;
                  },
                },
              }}
            />
          </div>
        </div>
      )}
      <div className="row ml-0">
        <div className="col-lg-6">
          <SelectEditor
            label="Ange tillverkningsår på ventilationsaggregat"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("tillverkningsår")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_tillverkningsår")}
            items={tillverkningsårList}
            formHook={formHook}
          />
        </div>
      </div>

      {/********************  Motoreffekt ventilationsaggregat  */}
      <div className="row ml-0 mt-4">
        <h5>Motoreffekt ventilationsaggregat </h5>
      </div>
      <div className="row ml-0">
        <div className="col-lg-6">
          <SelectEditor
            label="Uppgift om motoreffekt ventilationsaggregat"
            fieldName={nameof<IModuleVentilationFTXochFTConfig>("motoreffektUppgift")}
            tooltipId={nameof<MapTooltip>("VentilationFTXoFT_motoreffektUppgift")}
            items={motoreffektList}
            formHook={formHook}
          />
        </div>
      </div>
      {motoreffektUppgift === "Uppgift saknas" ? (
        <div className="row ml-0">
          <div className="col-lg-12">
            <label className="form-label w-100">
              <div className="input-group">
                <input disabled={true} className="form-control" value={"Schablonvärde beräknas (Motoreffekt TF+FF KW)"} />
              </div>
            </label>
          </div>
        </div>
      ) : (
        <div className="row ml-0">
          <div className="col-lg-6">
            <NumberEditor
              label="Ange motoreffekt tilluft vid max kapacitet (Kilowatt KW)"
              fieldName={nameof<IModuleVentilationFTXochFTConfig>("motoreffektTilluft")}
              tooltipId={nameof<MapTooltip>("VentilationFTXoFT_motoreffektTilluft")}
              min={0.1}
              max={20}
              step={0.1}
              formHook={formHook}
              options={{
                validate: {
                  required: (v) => {
                    return !v ? "Måste fyllas i" : undefined;
                  },
                  negativeNumber: (value: any) => (parseFloat(value) <= 0 ? "Måste vara positivt värde" : undefined),
                },
              }}
            />
          </div>
          <div className="col-lg-6">
            <NumberEditor
              label="Ange motoreffekt frånluft vid max kapacitet (Kilowatt KW)"
              fieldName={nameof<IModuleVentilationFTXochFTConfig>("motoreffektFrånluft")}
              tooltipId={nameof<MapTooltip>("VentilationFTXoFT_motoreffektFrånluft")}
              min={0.1}
              max={20}
              step={0.1}
              formHook={formHook}
              options={{
                validate: {
                  required: (v) => {
                    return !v ? "Måste fyllas i" : undefined;
                  },
                  negativeNumber: (value: any) => (parseFloat(value) <= 0 ? "Måste vara positivt värde" : undefined),
                },
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ConfigVentilationFTXochFT;
